import { createApi } from '@reduxjs/toolkit/query/react';
import axiosBaseQuery from '../../services/api/axiosBaseQuery';
import {
  GetEmployeesParams,
  GetProjectsParams,
  ReportsApiURL,
} from '../../services/api/reportsServices';
import { GetEmployeesParams as GetEmployeesInterface } from '../../services/api/employeeServices';
import { Employee } from '../../models/employee';
import { ApiResponse } from '../../services/httpService';

import { Project } from '../../models/project';
import { EmployeesApiUrl } from '../../services/api/employeeServices';

export interface GetProjectsByEmployeeIdParams {
  employeeId?: string;
  params?: GetProjectsParams;
}

export interface GetEmployeesByProjectIdParams {
  projectId?: string;
  params?: GetEmployeesParams;
}

export const reportsService = createApi({
  reducerPath: 'reportsService',
  baseQuery: axiosBaseQuery(),
  tagTypes: ['Reports'],

  endpoints: (builder) => ({
    getEmployees: builder.query<Employee[], GetEmployeesParams>({
      query: (params) => ({
        url: `${ReportsApiURL}/employees`,
        params,
      }),
      providesTags: ['Reports'],
      transformResponse: (response: ApiResponse<Employee>) => {
        return response.items;
      },
      keepUnusedDataFor: 30,
    }),

    getManagers: builder.query<Employee[], GetEmployeesInterface>({
      query: (params) => ({
        url: EmployeesApiUrl,
        params,
      }),
      providesTags: ['Reports'],
      transformResponse: (response: ApiResponse<Employee>) => {
        return response.items;
      },
      keepUnusedDataFor: 30,
    }),

    getEmployeesByProjectId: builder.query<
      Employee[],
      GetEmployeesByProjectIdParams
    >({
      query: ({ projectId, ...params }) => ({
        url: `${ReportsApiURL}/employees/${projectId}`,
        ...params,
      }),
      providesTags: ['Reports'],
      transformResponse: (response: ApiResponse<Employee>) => {
        return response.items;
      },
      keepUnusedDataFor: 30,
    }),

    getProjects: builder.query<Project[], GetProjectsParams>({
      query: (params) => ({
        url: `${ReportsApiURL}/projects`,
        params,
      }),
      providesTags: ['Reports'],
      transformResponse: (response: ApiResponse<Project>) => {
        return response.items;
      },
      keepUnusedDataFor: 30,
    }),

    getProjectsByEmployeeId: builder.query<
      Project[],
      GetProjectsByEmployeeIdParams
    >({
      query: ({ employeeId, ...params }) => ({
        url: `${ReportsApiURL}/projects/${employeeId}`,
        ...params,
      }),
      providesTags: ['Reports'],
      transformResponse: (response: ApiResponse<Project>) => {
        return response.items;
      },
      keepUnusedDataFor: 30,
    }),
  }),
});

export const {
  useGetEmployeesQuery,
  useGetManagersQuery,
  useGetEmployeesByProjectIdQuery,
  useGetProjectsQuery,
  useGetProjectsByEmployeeIdQuery,
} = reportsService;
